(function () {
    'use strict';

    /**
     * @ngdoc overview
     * @name UIEvents
     *
     * @description
     * Constants for each UI event, they're used when capturing logs related to user actions
     */
    angular.module('GorillaBoy')
    .constant('UIEvents', {
        FILE_BROWSER : {
            DROPDOWN_MENU_CLICKS : {
                CHECKIN : 'FILE_BROWSER.DROPDOWN_MENU_CLICKS.CHECKIN',
                CHECKOUT : 'FILE_BROWSER.DROPDOWN_MENU_CLICKS.CHECKOUT',
                DISCARD_CHECKOUT : 'FILE_BROWSER.DROPDOWN_MENU_CLICKS.DISCARD_CHECKOUT',
                REQUEST_CHECKIN : 'FILE_BROWSER.DROPDOWN_MENU_CLICKS.REQUEST_CHECKIN',
                TOGGLE_DOWNLOADS : 'FILE_BROWSER.DROPDOWN_MENU_CLICKS.TOGGLE_DOWNLOADS',
                TOGGLE_FEEDBACK : 'FILE_BROWSER.DROPDOWN_MENU_CLICKS.TOGGLE_FEEDBACK'
            },    
        },
        DOCUMENT_VIEWER : {
            DROPDOWN_MENU_CLICKS : {
                CHECKIN : 'DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.CHECKIN',
                CHECKOUT : 'DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.CHECKOUT',
                DISCARD_CHECKOUT : 'DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.DISCARD_CHECKOUT',
                REQUEST_CHECKIN : 'DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.REQUEST_CHECKIN',
                UNLOCK : 'DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.UNLOCK'
            },    
            FEEDBACK_PANEL : {
                UNLOCK : 'DOCUMENT_VIEWER.FEEDBACK_PANEL.UNLOCK'
            },
            SECURITY_TAB : {
                UNLOCK : 'DOCUMENT_VIEWER.SECURITY_TAB.UNLOCK'
            }
        },
        ACTION_BAR_CLICKS : {
            CHECKIN : 'ACTION_BAR_CLICKS.CHECKIN',
            CHECKOUT : 'ACTION_BAR_CLICKS.CHECKOUT',
            DISCARD_CHECKOUT : 'ACTION_BAR_CLICKS.DISCARD_CHECKOUT'
        }
    });
}());
